import { IExtendedSearchData } from "src/api/server/extended-search.types";
import { ISelectedRanking } from "../components/types";

export const getDefaultSearchRanking = (data: IExtendedSearchData): ISelectedRanking => {
    return {
        id: data.rankingsData.defaultSelectedRanking.id,
        sortDirection: data.rankingsData.defaultSelectedRanking.sortDirection,
    };
};
